import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
import dayjs from "dayjs";

const manageSalaryApi = factory.get("manage_salary");

const initialState = {
  results: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      skip: 0,
      take: 25,
      page: 0,
      search: "",
      department_id: null,
      date: null,
      year: null,
      user_id: null,
      status_id: null,
    },
    filters_dialog: false,
  },
  status: [
    { id: 1, ar_name: "في الانتظار", en_name: "new", color: "warning" },
    { id: 2, ar_name: "موافقة", en_name: "Accept", color: "success" },
    { id: 3, ar_name: "مرفوضة", en_name: "Reject", color: "error" },
  ],
  manage_salary: {
    loading: false,
    dialog: false,
    form: {
      id: "",
      user_id: null,
      new_salary: null,
      description: null,
      super_admin_form: {
        status_id: null,
        approved_amount: 0,
        note: "",
      },
    },
  },
};

export const manageSalarySlice = createSlice({
  name: "manageSalary",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setDialog: (state, action) => {
      state.manage_salary.dialog = !state.manage_salary.dialog;
    },
    setDataTable: (state, { payload }) => {
      state.results.data = payload.data.data;
      state.results.total = payload.data.total;
    },
    setById: (state, { payload }) => {
      for (const key in state.manage_salary.form) {
        if (payload[key]) {
          state.manage_salary.form[key] = payload[key];
        }
      }
      state.manage_salary.form.user_id = {
        id: payload.employee_id,
        full_name: payload.employee_name,
        department_name: payload.department,
      };
      state.manage_salary.form.super_admin_form = {
        status_id: payload.status_id,
        approved_amount:
          payload.approved_amount !== "0.00"
            ? payload.approved_amount
            : payload.new_salary,
        note: payload.note,
      };
    },
    resetForm: (state, action) => {
      state.manage_salary.form = initialState.manage_salary.form;
    },
    setFiltersDialog: (state, action) => {
      state.results.filters_dialog = !state.results.filters_dialog;
    },
    setFilters: (state, { payload }) => {
      state.results.filters = {
        ...state.results.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.results.filters = initialState.results.filters;
    },
  },
});

export const {
  setLoading,
  setDialog,
  setDataTable,
  setById,
  resetForm,
  setFilters,
  setFiltersDialog,
  resetFilters,
} = manageSalarySlice.actions;

export default manageSalarySlice.reducer;

const toNumber = (value) => {
  return typeof value === "number" ? value : parseInt(value.replace(/,/g, ""));
};

//axios
const getAll = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading("results"));
    const filters = getState().manageSalary.results.filters;
    const filters_ = {
      ...filters,
      user_id: filters.user_id?.id || null,
      department_id: filters.department_id?.id || null,
    };
    const res = await manageSalaryApi.getAll(filters_);
    dispatch(setDataTable(res));
    dispatch(setLoading("results"));
  } catch (err) {
    dispatch(setLoading("results"));
    throw new Error(err);
  }
};
const deleteById = (id) => async (dispatch) => {
  try {
    await manageSalaryApi.delete(id);
    dispatch(
      showNotification({
        message: "تم حذف  بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("manage_salary"));
    const res = await manageSalaryApi.getById(id);
    dispatch(setById(res.data.data[0]));
    dispatch(setDialog());
    dispatch(setLoading("manage_salary"));
  } catch (err) {
    dispatch(setLoading("manage_salary"));
    throw new Error(err);
  }
};
const create = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("manage_salary"));
    const form = {
      ...data,
      user_id: data.user_id?.id,
      new_salary: toNumber(data.new_salary),
      // date: `${dayjs(data.date).format("YYYY-MM")}-01`,
    };
    delete form.super_admin_form;
    await manageSalaryApi.create(form);
    dispatch(setLoading("manage_salary"));
    dispatch(
      showNotification({
        message: "تم الاضافة بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(getAll());
  } catch (err) {
    dispatch(setLoading("manage_salary"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const update = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("manage_salary"));
    const form = {
      ...data,
      user_id: data.user_id?.id,
      new_salary: toNumber(data.new_salary),
      // date: `${dayjs(data.date).format("YYYY-MM")}-01`,
    };
    delete form.super_admin_form;
    await manageSalaryApi.update(form);
    dispatch(setDialog());
    dispatch(
      showNotification({
        message: "تم التعديل بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
    dispatch(setLoading("manage_salary"));
  } catch (err) {
    dispatch(setLoading("manage_salary"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const changeStatusForm = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("manage_salary"));
    let form = {};
    if (data.super_admin_form) {
      form = {
        id: data.id,
        note: data.super_admin_form.note,
        user_id: data.user_id?.id,
        status_id: data.super_admin_form.status_id,
        approved_amount: toNumber(data.super_admin_form.approved_amount),
      };
    } else {
      form = {
        ...data,
      };
    }
    await manageSalaryApi.changeStatusWithInfo(form);
    if (data.super_admin_form) {
      dispatch(setDialog());
    }
    dispatch(
      showNotification({
        message: "تم التعديل بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
    dispatch(setLoading("manage_salary"));
  } catch (err) {
    dispatch(setLoading("manage_salary"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const ManageSalary = {
  getAll,
  deleteById,
  getById,
  create,
  update,
  changeStatusForm,
};
